/**
 * Shared rule for USER PICKERS across the app.
 *
 * A user is "pickable" (selectable as an assignee, participant, reviewer,
 * approver, member, owner, admin, …) only when their record is BOTH active
 * AND approved. An inactive or not-yet-approved user record is not a usable
 * identity and must never appear in a selection dropdown.
 *
 * Management TABLES (e.g. Organisation → Users, Super Admin → Users) still
 * show everyone — this filter is for pickers only.
 *
 * The paginated `/usr/users` (getAllUsers) and `/usr/users/dropdown*`
 * endpoints return objects carrying `is_active` / `is_approved`; use this to
 * filter any user list borrowed from a management endpoint before rendering
 * it as options.
 */
export interface PickableUser {
  is_active?: number | null;
  is_approved?: number | null;
}

/** True when the user record is active (1) AND approved (1). */
export const isPickableUser = (u: PickableUser): boolean =>
  Number(u?.is_active) === 1 && Number(u?.is_approved) === 1;

/** Keep only active + approved users. Generic over the row shape. */
export const filterPickableUsers = <T extends PickableUser>(users: T[]): T[] =>
  (users || []).filter(isPickableUser);
